interface IProps {
  index: number;
  total: number;
}
export const SwiperPagination = ({ index, total }: IProps) => {
  return (
    <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-vertical">
      {Array.from(Array(total).keys()).map((key: number) => (
        <span
          key={key + 1}
          className={
            key === index
              ? 'swiper-pagination-bullet swiper-pagination-bullet-active'
              : 'swiper-pagination-bullet'
          }
        ></span>
      ))}
    </div>
  );
};
